module.exports = __webpack_public_path__ + "img/path.b22bfe67.svg";